export default __webpack_public_path__ + "static/media/3-7t.256a1323.png";